import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {LessonSchedule} from "../classes/LessonSchedule";

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'}),
};

@Injectable({
  providedIn: 'root',
})
export class LessonsScheduleService {

  constructor(private httpClient: HttpClient) {
  }

  public getAllByTeacher(teacherId: number | null): Observable<LessonSchedule[]> {
    const params = teacherId ? `?teacherId=${teacherId}` : '';
    return this.httpClient.get<LessonSchedule[]>(`${environment.backendApiUrl}/v1/lessons-schedule/teacher${params}`, httpOptions);
  }

  getScheduledLessonsByDateRange(startDate?: string, endDate?: string, isAutogenerated?: boolean): Observable<any> {
    let params = '';
    if (startDate && endDate) {
      params = `?start=${startDate}&end=${endDate}`;
    }
    if (isAutogenerated !== undefined) {
      params += `&isAutogenerated=${isAutogenerated}`;
    }
    return this.httpClient.get<LessonSchedule[]>(`${environment.backendApiUrl}/v1/lessons-schedule${params}`, httpOptions);
  }

  public createOrEdit(lessonSchedule: LessonSchedule): Observable<void> {
    if (lessonSchedule.id) {
      return this.httpClient
        .put<void>(`${environment.backendApiUrl}/v1/lessons-schedule/` + lessonSchedule.id, lessonSchedule, httpOptions);
    }
    return this.httpClient.post<void>(`${environment.backendApiUrl}/v1/lessons-schedule`, lessonSchedule, httpOptions);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/lessons-schedule/` + id, httpOptions);
  }
}
